import branch, { BranchError, SessionData } from 'branch-sdk';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Loader } from '../../components';
import Logger from '../../logger';
import { ScreenState } from '../../types';
import { setCookie } from '../../utils';
import AuraHeader from './components/aura-header.coponent';
import AuraSection from './components/aura-section.component';

const Aura: React.FC = () => {
  const [state, setState] = useState<ScreenState>(ScreenState.LOADING);
  const [accountId, setAccountId] = useState<string>('');

  useEffect(() => {
    branch.data((err: BranchError, data: SessionData | null) => {
      err && Logger.error('Branch Error: ' + err);
      if (data?.data_parsed && (data?.data_parsed as any)?.accountId) {
        const parsedData = data.data_parsed as any;
        setAccountId(parsedData.accountId)
        setState(ScreenState.DEFAULT);
        parsedData.token && setCookie('token', parsedData.token, 1);
      }
    });
  }, []);

  const loading = state === ScreenState.LOADING;

  return (
    <>
      <AuraHeader/>
      {loading ? (
        <Loader containerCls="pageLoader" />
      ) : (
        <AuraSection accountId={accountId}/>
      )}
    </>
  );
};

export default Aura;
